import React, { useState } from 'react';
import { Checkbox, Col, Row, Modal, Space, Button } from 'antd';
import { gql } from '@apollo/client/core';
import { useQuery } from '@apollo/client';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { TableFieldUpdateViewProps } from '../../../search_old/types';
import {
  CustomFieldFragmentFragment,
  EntityCustomFieldCheckableOptionsQueryQuery,
  EntityCustomFieldCheckableOptionsQueryQueryVariables,
  UpdateSelectCustomFieldValueForRecord
} from '../../../../../gql/typings';
import { getVariableField } from '../../../person/fields/utils/personFieldsUtils';
import { usePersonFieldMutation } from '../../../person/Components/attributeFields/AttributeFields/usePersonFieldMutation';
import CustomFieldCheckableTagInput from './CustomFieldCheckableTagInput';
import { isActualNumber } from '../../../../util/Util';
import Loading from '../../../../components/Loading/Loading';
import { Locale } from '../../../../../localization/LocalizationKeys';
import { useLocalization } from '../../../../util/useLocalization';
import { CUSTOM_UPSERT_MUTATION } from './customFieldUtils';

const CustomCheckboxInput: React.FC<TableFieldUpdateViewProps> = (props) => {
  const values = getVariableField(props!.record, props!.options, 'customFields');
  const selected = values.nodes.map((it: NonNullable<CustomFieldFragmentFragment['options']>['nodes']['0']) => it.value!.id);
  const [visible, setVisible] = useState(true);
  const localization = useLocalization();
  const { data, loading } = useQuery<EntityCustomFieldCheckableOptionsQueryQuery
  , EntityCustomFieldCheckableOptionsQueryQueryVariables>(CHECK_QUERY_OPTIONS, {
    variables: {
      code: props.options.selectedOption!.code as string
    },
    fetchPolicy: 'network-only'
  });
  const { submit, blocking } = usePersonFieldMutation({
    mutation: CUSTOM_UPSERT_MUTATION,
    controlSetting: props.record?.controlSetting,
    skipDcrWarning: true,
  });

  const onChange = (newSelected: CheckboxValueType[]) => {
    if (!blocking) {
      const selectedValues: UpdateSelectCustomFieldValueForRecord[] = newSelected.map(ns => {
        if (isActualNumber(ns)) return { valueId: ns };
        return { newValue: ns as string };
      });

      submit({
        customFieldCode: props.options.selectedOption?.code,
        recordId: props.record.id,
        customValues: selectedValues
      }).finally(() => props.options.refetchData());
    }
  };

  const close = () => {
    if (!blocking) {
      setVisible(false);
      props.endEditing();
    }
  };

  if (loading) return <Loading spinSize='small' />;

  return (
    <Modal
      title={props?.options.selectedOption?.label}
      open={visible}
      onCancel={close}
      closable={false}
      footer={false}
      width="clamp(320px, 75%, 480px)"
      wrapClassName='custom-field-modal-container'
    >
      {
        !data?.customField?.isCheckableTag ? <Checkbox.Group
          style={{ width: '100%' }}
          value={selected}
          onChange={onChange}
        >
          <Row>
            {(data?.customField?.options?.nodes ?? [])
              .map((option: NonNullable<CustomFieldFragmentFragment['options']>['nodes']['0']) => (
                <Col key={option.value!.id} span={24}>
                  <Checkbox key={option.value!.id} value={option.value!.id}>
                    {option.value!.value}
                  </Checkbox>
                </Col>
              ))}
          </Row>
        </Checkbox.Group>
          : <CustomFieldCheckableTagInput {...props} />
      }
      <Space style={{ width: '100%', justifyContent: 'center', marginTop: 20 }}>
        {
          blocking ? <Loading spinSize='small' />
            : <Button key="2" type="primary" className="save-button" onClick={close}>
              {localization.formatMessage(Locale.General.Ok)}
            </Button>
        }
      </Space>
    </Modal>
  );
};

const CHECK_QUERY_OPTIONS = gql`
  query EntityCustomFieldCheckableOptionsQuery($code: String!) {
    customField(code: $code) {
      isCheckableTag
      options {
        hash
        nodes {
          id
          value {
            id
            value
          }
        }
      }
    }
  }
`;

export default CustomCheckboxInput;
